module.exports = {"pathContext":{"slug":"/en/dbd_p/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/en-dbd-p.json
// module id = 1524
// module chunks = 49790051903035